import { useCallback, useEffect, useState } from 'react';
import { useDormitoryRoomsCapacity } from '@/hooks';
import { AppButton, CardSelector, Flex, LoadingSpin } from '@/components';
import { DormitoryHttp } from '@/services';
import { useTranslation } from 'react-i18next';

interface DormitoryRegisterGroupCreateProps {
  request: DormitoryRequestEntity;
  onRefresh?: () => void;
}

export default function DormitoryRegisterGroupCreate({
  request,
  onRefresh
}: DormitoryRegisterGroupCreateProps) {

  const [t] = useTranslation(['common', 'dormitory']);
  const [selectedCapacity, setSelectedCapacity] = useState<number>(null);
  const { roomsCapacity, fetchRoomsCapacity, error, loading: capacityLoading } = useDormitoryRoomsCapacity();
  const dormitoryId = request?.destinationDormitory?.id;

  const handleCreateGroup = useCallback(async () => {
    try {
      const payload = { dormitoryId, roomSize: selectedCapacity, solitary: false };
      await DormitoryHttp.createDormitoryGroup(payload);
      if (typeof onRefresh === 'function') onRefresh();
    }
    catch (e) {
      console.error(e);
    }
  }, [selectedCapacity, dormitoryId, onRefresh]);

  useEffect(() => {
    if (!dormitoryId) return;
    fetchRoomsCapacity(dormitoryId);
  }, [dormitoryId]);

  return (
    <Flex align="center" direction="column">
      <span className="font-medium mb-5 text-mid">
        {t('dormitory:messages.select-capacity')}
      </span>
      {capacityLoading ? <LoadingSpin text={t('common:labels.loading-data')} /> : (
        <CardSelector
          itemSize="70px"
          items={roomsCapacity}
          onChange={(value) => setSelectedCapacity(value)}
          render={(value) => (
            <Flex gap={0} inlineFlex direction="column" className="text-[#555]">
              <span className="text-lg font-semibold">{value}</span>
              <span className="text-sm font-medium">{t('common:labels.person')}</span>
            </Flex>
          )}
        />
      )}
      <AppButton
        className="mt-5"
        type="primary"
        appVariant="dormitory"
        onClick={handleCreateGroup}
        disabled={capacityLoading || selectedCapacity == null || error != null}
      >
        {t('dormitory:labels.create-new-group')}
      </AppButton>
    </Flex>
  );
}
